import { getId } from '@/utils/temporaryHelper'

export const InitialNodeIds = {
  main: {
    page1: getId(),
    page2: getId(),
    page3: getId(),
    root: getId(),
  },
  secondary: {
    cookies: getId(),
    error404: getId(),
  },
}
